export type AppNavItem = {
  label: string;
  to: string;
  permission?: string;
  agencyOnly?: boolean;
  /** Hidden for agency CLIENT login accounts. */
  hideForClient?: boolean;
  /** Hidden for Ad Agency team member (sub-account) logins. */
  hideForTeamMember?: boolean;
  icon:
    | 'home'
    | 'screens'
    | 'nearby'
    | 'campaign'
    | 'clients'
    | 'team'
    | 'gallery'
    | 'coupon'
    | 'wishlist'
    | 'wallet'
    | 'profile'
    | 'notifications'
    | 'tutorial'
    | 'policies'
    | 'support'
    | 'total-analytics';
};

export type AppNavGroup = {
  title?: string;
  items: AppNavItem[];
};

export const appNavGroups: AppNavGroup[] = [
  {
    title: 'Main',
    items: [
      {
        label: 'Dashboard',
        to: '/dashboard',
        icon: 'home',
        hideForClient: true,
        hideForTeamMember: true,
      },
      { label: 'Screens', to: '/screens', icon: 'screens' },
      { label: 'Nearby Screens', to: '/nearby-screens', icon: 'nearby' },
      {
        label: 'Campaigns',
        to: '/campaigns',
        icon: 'campaign',
        // Team members always get campaigns (scoped to assigned clients on API).
        // Sub-account permission still applies when the flag is set for other roles.
        permission: 'campaigns_module_access',
      },
      { label: 'Client', to: '/clients', icon: 'clients', agencyOnly: true },
      { label: 'Team', to: '/team', icon: 'team', agencyOnly: true },
      {
        label: 'Pre-Approved Gallery',
        to: '/gallery',
        icon: 'gallery',
        permission: 'gallery_module_access',
        hideForClient: true,
        hideForTeamMember: true,
      },
      {
        label: 'Coupons & Offers',
        to: '/coupon',
        icon: 'coupon',
        permission: 'offer_coupon_module_access',
        hideForClient: true,
        hideForTeamMember: true,
      },
      {
        label: 'Wishlist',
        to: '/wishlist',
        icon: 'wishlist',
        permission: 'wishlist_module_access',
        // hideForClient: true,
        hideForTeamMember: true,
      },
      {
        label: 'Wallet',
        to: '/wallet',
        icon: 'wallet',
        permission: 'wallet_module_access',
        hideForClient: true,
        hideForTeamMember: true,
      },
    ],
  },
  {
    title: 'Account',
    items: [
      { label: 'My Profile', to: '/profile', icon: 'profile' },
      { label: 'Notifications', to: '/notification', icon: 'notifications' },
      { label: 'Total Analytics', to: '/total-analytics', icon: 'total-analytics' },
    ],
  },
  {
    title: 'Resources',
    items: [
      { label: 'Tutorial', to: '/app-tutorial', icon: 'tutorial' },
      { label: 'Explore Policies', to: '/policies', icon: 'policies' },
      { label: 'Help Support', to: '/support', icon: 'support' },
    ],
  },
];
